import { Monitor, Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useTheme, type ThemePreference } from '@/shared/hooks/useTheme'
import { SegmentedControl, type SegmentedOption } from './SegmentedControl'

/** Bascule de thème (auto/clair/sombre) - préférence profil, DESIGN §2. */
export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()

  const options: SegmentedOption<ThemePreference>[] = [
    { value: 'auto', label: t('shared.appearance.theme.auto'), icon: Monitor },
    { value: 'light', label: t('shared.appearance.theme.light'), icon: Sun },
    { value: 'dark', label: t('shared.appearance.theme.dark'), icon: Moon },
  ]

  return (
    <SegmentedControl
      options={options}
      value={theme}
      onChange={setTheme}
      ariaLabel={t('shared.appearance.theme.label')}
      className={className}
    />
  )
}
